module.exports = __webpack_public_path__ + "img/4.22e6e158.png";